exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.estilo_jep[data-v-135345dc] {\n  background-color: #0b121f;\n}\n.primary--text[data-v-135345dc] {\n  color: red;\n}\n.section-preview[data-v-135345dc] {\n  border: 1px solid #e0e0e0;\n  padding: 15px;\n}\n*[data-v-135345dc]{ text-transform: none !important;\n}\n.estilo_dos_columnas[data-v-135345dc] {\n  width: 50%;\n  margin-left:5px;\n  margin-top:5px;\n}\n.estilo_tres_columnas[data-v-135345dc] {\n  width: 33%;\n  padding-right:10px;\n  padding-top:15px;\n}\n.theme--dark.v-stepper--vertical .v-stepper__content[data-v-135345dc]:not(:last-child) {\n  border-left: 0px;\n}\n", ""]);

// exports
